import React from 'react';
import { getMediaUrl } from '../../services/api';

const SLOT_LABELS = { headshot: 'Hero', about: 'About', gallery: 'Gallery' };

const templates = [
  {
    id: 'bold',
    name: 'Bold',
    description: 'Full-bleed photos, wide typography, duotone effects. Modern & striking.',
    preview: 'bold',
  },
  {
    id: 'clean',
    name: 'Clean',
    description: 'Minimal and professional. Lots of whitespace, clean typography, agency-ready.',
    preview: 'clean',
  },
  {
    id: 'creative',
    name: 'Creative',
    description: 'Fun and expressive. Colorful accents, playful layouts, bold personality.',
    preview: 'creative',
  },
  {
    id: 'pop',
    name: 'Pop',
    description:
      'Big, bold hero with full-color background. No nav bar — CTA buttons navigate sections.',
    preview: 'pop',
  },
];

const accentColors = [
  { color: '#00D9C0', name: 'Teal' },
  { color: '#8553D1', name: 'Purple' },
  { color: '#FF6B6B', name: 'Coral' },
  { color: '#FFD93D', name: 'Gold' },
  { color: '#6BCB77', name: 'Green' },
  { color: '#4D96FF', name: 'Blue' },
  { color: '#FF8FB1', name: 'Pink' },
  { color: '#000000', name: 'Black' },
];

const fontOptions = [
  { value: 'Inter', label: 'Inter' },
  { value: 'Cormorant Garamond', label: 'Cormorant Garamond' },
  { value: 'Space Grotesk', label: 'Space Grotesk' },
  { value: 'Unbounded', label: 'Unbounded' },
  { value: 'Playfair Display', label: 'Playfair Display' },
  { value: 'Lora', label: 'Lora' },
  { value: 'Montserrat', label: 'Montserrat' },
  { value: 'Raleway', label: 'Raleway' },
  { value: 'Poppins', label: 'Poppins' },
  { value: 'DM Sans', label: 'DM Sans' },
  { value: 'DM Serif Display', label: 'DM Serif Display' },
  { value: 'Libre Baskerville', label: 'Libre Baskerville' },
];

function DesignTab({
  profileSettings,
  setProfileSettings,
  photos,
  uploading,
  handleLibraryUpload,
  handleDeletePhoto,
  handleSaveSettings,
  saving,
}) {
  return (
    <>
      <div className="settings-card">
        <div className="settings-card-header">
          <h2>Template</h2>
          <p>Choose a curated and customizable template.</p>
        </div>
        <div className="template-grid">
          {templates.map((template) => (
            <div
              key={template.id}
              className={`template-card ${profileSettings.theme === template.id ? 'selected' : ''}`}
              onClick={() => setProfileSettings({ ...profileSettings, theme: template.id })}
            >
              <div className={`template-preview template-preview-${template.preview}`}>
                {template.id === 'bold' && (
                  <div className="template-preview-bold">
                    <div className="tpb-hero">
                      <div className="tpb-nav"></div>
                      <div className="tpb-photo"></div>
                      <div className="tpb-name">JANE DOE</div>
                    </div>
                    <div className="tpb-about">
                      <div
                        className="tpb-about-img"
                        style={{ background: profileSettings.accent_color || '#00D9C0' }}
                      ></div>
                      <div className="tpb-about-text">
                        <div className="tpb-title">ABOUT</div>
                        <div className="tpb-lines"></div>
                      </div>
                    </div>
                    <div className="tpb-gallery">
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                )}
                {template.id === 'clean' && (
                  <div className="template-preview-clean">
                    <div className="tpcl-nav">
                      <div className="tpcl-nav-name"></div>
                      <div className="tpcl-nav-links">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                    <div className="tpcl-hero">
                      <div className="tpcl-hero-text">
                        <div className="tpcl-name">Jane Doe</div>
                        <div className="tpcl-tagline"></div>
                        <div
                          className="tpcl-btn"
                          style={{ background: profileSettings.accent_color || '#000000' }}
                        ></div>
                      </div>
                      <div className="tpcl-hero-photo"></div>
                    </div>
                    <div className="tpcl-section">
                      <div className="tpcl-label"></div>
                      <div className="tpcl-grid">
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                )}
                {template.id === 'creative' && (
                  <div className="template-preview-creative">
                    <div
                      className="tpcr-nav"
                      style={{ background: profileSettings.accent_color || '#e32c74' }}
                    >
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                    <div
                      className="tpcr-hero"
                      style={{
                        background: `linear-gradient(135deg, ${profileSettings.accent_color || '#e32c74'}, ${profileSettings.accent_color || '#e32c74'}88)`,
                      }}
                    >
                      <div className="tpcr-photo"></div>
                      <div className="tpcr-name">Jane Doe</div>
                      <div className="tpcr-pills">
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                    <div className="tpcr-gallery">
                      <div></div>
                      <div className="tpcr-tall"></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                )}
                {template.id === 'pop' && (
                  <div className="template-preview-pop">
                    <div className="tpp-nav">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                    <div
                      className="tpp-hero"
                      style={{ background: profileSettings.accent_color || '#C8A96E' }}
                    >
                      <div className="tpp-photo"></div>
                      <div className="tpp-text">
                        <div className="tpp-name">
                          JANE
                          <br />
                          DOE
                        </div>
                        <div className="tpp-tagline">ACTOR · MODEL</div>
                      </div>
                    </div>
                    <div
                      className="tpp-stripe"
                      style={{ background: profileSettings.accent_color || '#C8A96E' }}
                    ></div>
                  </div>
                )}
              </div>
              <div className="template-info">
                <h3>{template.name}</h3>
                <p>{template.description}</p>
              </div>
              {profileSettings.theme === template.id && (
                <div className="template-selected-badge">Selected</div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="settings-card">
        <div className="settings-card-header">
          <h2>Accent Color</h2>
          <p>Your brand color for highlights</p>
        </div>
        <div className="accent-color-grid">
          {accentColors.map((item) => (
            <button
              key={item.color}
              className={`accent-color-btn ${profileSettings.accent_color === item.color ? 'selected' : ''}`}
              style={{ backgroundColor: item.color }}
              onClick={() => setProfileSettings({ ...profileSettings, accent_color: item.color })}
              title={item.name}
            >
              {profileSettings.accent_color === item.color && (
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
              )}
            </button>
          ))}
          <div className="accent-color-custom">
            <input
              type="color"
              value={profileSettings.accent_color || '#00D9C0'}
              onChange={(e) =>
                setProfileSettings({ ...profileSettings, accent_color: e.target.value })
              }
              title="Custom color"
            />
            <span>Custom</span>
          </div>
        </div>
      </div>

      {/* Typography */}
      <div className="settings-card">
        <div className="settings-card-header">
          <h2>Typography</h2>
          <p>Fonts and sizing for your portfolio</p>
        </div>

        <div className="typography-controls">
          <div className="form-group">
            <label>Heading Font</label>
            <select
              value={profileSettings.heading_font || 'Inter'}
              onChange={(e) =>
                setProfileSettings({ ...profileSettings, heading_font: e.target.value })
              }
              style={{ fontFamily: profileSettings.heading_font || 'Inter' }}
            >
              {fontOptions.map((f) => (
                <option key={f.value} value={f.value} style={{ fontFamily: f.value }}>
                  {f.label}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Body Font</label>
            <select
              value={profileSettings.body_font || 'Inter'}
              onChange={(e) =>
                setProfileSettings({ ...profileSettings, body_font: e.target.value })
              }
              style={{ fontFamily: profileSettings.body_font || 'Inter' }}
            >
              {fontOptions.map((f) => (
                <option key={f.value} value={f.value} style={{ fontFamily: f.value }}>
                  {f.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="font-size-control">
          <label>Heading Size</label>
          <div className="font-size-slider">
            <input
              type="range"
              min="20"
              max="60"
              value={profileSettings.heading_font_size || '32'}
              onChange={(e) =>
                setProfileSettings({ ...profileSettings, heading_font_size: e.target.value })
              }
            />
            <span className="font-size-value">{profileSettings.heading_font_size || '32'}px</span>
          </div>
        </div>

        <div className="font-size-control">
          <label>Body Size</label>
          <div className="font-size-slider">
            <input
              type="range"
              min="12"
              max="24"
              value={profileSettings.body_font_size || '16'}
              onChange={(e) =>
                setProfileSettings({ ...profileSettings, body_font_size: e.target.value })
              }
            />
            <span className="font-size-value">{profileSettings.body_font_size || '16'}px</span>
          </div>
        </div>

        <div className="font-preview-block">
          <h4>Preview</h4>
          <div
            className="font-preview-heading"
            style={{
              fontFamily: `'${profileSettings.heading_font || 'Inter'}', sans-serif`,
              fontSize: `${profileSettings.heading_font_size || 32}px`,
              fontWeight: 700,
            }}
          >
            Your Portfolio Name
          </div>
          <div
            className="font-preview-body"
            style={{
              fontFamily: `'${profileSettings.body_font || 'Inter'}', sans-serif`,
              fontSize: `${profileSettings.body_font_size || 16}px`,
            }}
          >
            This is how your body text will look on your portfolio.
          </div>
        </div>
      </div>

      {/* Photo Library */}
      <div className="settings-card">
        <div className="settings-card-header">
          <h2>Photo Library</h2>
          <p>
            Upload all your photos here. Then choose which ones go on each section of your
            portfolio.
          </p>
        </div>
        <label
          className="photo-library-upload-area"
          onDragOver={(e) => {
            e.preventDefault();
            e.currentTarget.classList.add('drag-over');
          }}
          onDragLeave={(e) => {
            e.currentTarget.classList.remove('drag-over');
          }}
          onDrop={(e) => {
            e.preventDefault();
            e.currentTarget.classList.remove('drag-over');
            handleLibraryUpload(e.dataTransfer.files);
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="17 8 12 3 7 8" />
            <line x1="12" y1="3" x2="12" y2="15" />
          </svg>
          <span>{uploading ? 'Uploading...' : 'Drag & drop or click to upload'}</span>
          <small>JPG, PNG — up to 5 at once</small>
          <input
            type="file"
            accept="image/*"
            multiple
            style={{ display: 'none' }}
            onChange={(e) => handleLibraryUpload(e.target.files)}
            disabled={uploading}
          />
        </label>
        {photos.length > 0 ? (
          <div className="photo-library-grid">
            {photos.map((photo) => (
              <div key={photo.id} className="photo-library-item">
                <img src={getMediaUrl(photo.url)} alt="" />
                {photo.slot && (
                  <div className="photo-library-slot-badge">
                    {SLOT_LABELS[photo.slot] || photo.slot}
                  </div>
                )}
                <button
                  className="photo-library-delete"
                  onClick={() => handleDeletePhoto(photo.id)}
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                </button>
              </div>
            ))}
          </div>
        ) : (
          <p className="photo-library-empty">No photos yet. Upload some to get started!</p>
        )}
      </div>

      <button className="btn-save-section" onClick={handleSaveSettings} disabled={saving}>
        {saving ? 'Saving...' : 'Save Design'}
      </button>
    </>
  );
}

export default DesignTab;
